// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"HugeLogo_ProseMirror__DLKL-","hugeLogo":"HugeLogo_hugeLogo__2nvtv","hugeLogo_clickable":"HugeLogo_hugeLogo_clickable__jIsHL"};